import { render } from "./InformeTotal.vue?vue&type=template&id=37fd8db7&scoped=true"
import script from "./InformeTotal.vue?vue&type=script&lang=js"
export * from "./InformeTotal.vue?vue&type=script&lang=js"

import "./InformeTotal.vue?vue&type=style&index=0&id=37fd8db7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fd8db7"]])

export default __exports__